import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MenuMainComponent } from "app/pages/menu/menu-main/menu-main.component";
import { MenuMainContentComponent } from "app/pages/menu/menu-main/menu-main-content/menu-main-content.component";
import { EditProductModalComponent } from "app/pages/menu/shared/edit-product-modal/edit-product-modal.component";
import { EditModifierGroupComponent } from "app/pages/menu/shared/edit-product-modal/edit-modifier-group/edit-modifier-group.component";
import { EditModifierComponent } from "app/pages/menu/shared/edit-product-modal/edit-modifier/edit-modifier.component";
import { EditComboGroupComponent } from "app/pages/menu/shared/edit-product-modal/edit-combo-group/edit-combo-group.component";
import { EditComboProductComponent } from "app/pages/menu/shared/edit-product-modal/edit-combo-product/edit-combo-product.component";
import { EditGroupModalComponent } from "app/pages/menu/shared/edit-group-modal/edit-group-modal.component";
import { ChangesForMenusComponent } from "app/pages/menu/shared/changes-for-menus/changes-for-menus.component";
import { AddButtonComponent } from "app/pages/menu/shared/buttons/add-button/add-button.component";
import { PageHeaderComponent } from "app/pages/menu/shared/page-header/page-header.component";
import { PageTitleComponent } from "app/pages/menu/shared/page-title/page-title.component";
import { PageSearchComponent } from "app/pages/menu/shared/page-search/page-search.component";
import { MenuChipsComponent } from "app/pages/menu/shared/menu-chips/menu-chips.component";
import { TagsFormFieldComponent } from "app/pages/menu/shared/tags-form-field/tags-form-field.component";
import { SelectImageFieldComponent } from "app/pages/menu/shared/select-image-field/select-image-field.component";
import { SectionGroupComponent } from "app/pages/menu/menu-main/menu-main-content/section-group/section-group.component";
import { SectionProductsComponent } from "app/pages/menu/menu-main/menu-main-content/section-products/section-products.component";
import { SectionProductComponent } from "app/pages/menu/menu-main/menu-main-content/section-products/section-product/section-product.component";
import { EditMenuModalComponent } from "app/pages/menu/shared/edit-menu-modal/edit-menu-modal.component";
import { SelectProductsModalComponent } from "app/pages/menu/shared/select-products-modal/select-products-modal.component";
import { SelectMenuGroupsModalComponent } from "app/pages/menu/shared/select-menu-groups-modal/select-menu-groups-modal.component";
import { ProductItemComponent } from "app/pages/menu/shared/product-item/product-item.component";
import { MenuSyncCardComponent } from "app/pages/menu/menu-sync-card/menu-sync-card.component";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatChipsModule } from "@angular/material/chips";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatListModule } from "@angular/material/list";
import { MatCardModule } from "@angular/material/card";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatDialogModule } from "@angular/material/dialog";
import { MatRadioModule } from "@angular/material/radio";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MenuEventModalComponent } from "app/pages/menu/shared/menu-event-modal/menu-event-modal.component";
import { PreloaderModule } from "app/components/preloader/preloaderModule";
import { EditSizeModalComponent } from './shared/edit-size-modal/edit-size-modal.component';
import { EditModifierGroupsModalComponent } from './shared/edit-product-modal/edit-combo-group/edit-modifier-groups-modal/edit-modifier-groups-modal.component';
import { MenuPipesModalComponent } from 'app/pages/menu/shared/menu-pipes-modal/menu-pipes-modal.component';
import {
  MigrateRelatedProductsDialogComponent
} from 'app/pages/menu/shared/migrate-related-products-dialog/migrate-related-products-dialog.component';
import { EditSizeScaleModalComponent } from './shared/edit-size-scale-modal/edit-size-scale-modal.component';
import { DeleteSizeScaleDialogComponent } from './shared/delete-size-scale-dialog/delete-size-scale-dialog.component';
import { MenuSchedulesModalComponent } from 'app/pages/menu/shared/menu-schedules-modal/menu-schedules-modal.component';
import { MenuSchedulesEntityModalComponent } from 'app/pages/menu/shared/menu-schedules-entity-modal/menu-schedules-entity-modal.component';
import { SelectProductsScheduleModalComponent } from './shared/select-products-schedule-modal/select-products-schedule-modal.component';
import { AllergenGroupComponent } from './shared/allergen-group/allergen-group.component';
import { EditTagModalComponent } from './shared/edit-tag-modal/edit-tag-modal.component';
import { TagsFormFieldOldComponent } from './shared/tags-form-field-old/tags-form-field-old.component';
import { EditMenuBackupComponent } from './shared/edit-menu-backup/edit-menu-backup.component';
import { SendProductModalComponent } from './shared/send-product-modal/send-product-modal.component';
import { ModifierGroupTypeModalComponent } from './shared/modifier-group-type-modal/modifier-group-type-modal.component';
import { SelectVideoFieldComponent } from './shared/select-video-field/select-video-field.component';
import { RelatedProductsComponent } from './shared/related-products/related-products.component';
import { EditRelatedProductsModalComponent } from './shared/edit-related-products-modal/edit-related-products-modal.component';
import {
  SelectGroupsScheduleModalComponent
} from 'app/pages/menu/shared/select-groups-schedule-modal/select-groups-schedule-modal.component';
import { RelatedProductsV3Component } from './shared/related-products-v3/related-products-v3.component';
import { EditRelatedProductsV3ModalComponent } from './shared/related-products-v3/edit-related-products-v3-modal/edit-related-products-v3-modal.component';
import { NutritionFormFieldComponent } from './shared/nutrition-form-field/nutrition-form-field.component';
import { ProductBarcodesComponent } from './shared/product-barcodes/product-barcodes.component';

const routes: Routes = [
  {
    path: 'main',
    component: MenuMainComponent,
    children: [
      {path: '', component: MenuMainContentComponent, pathMatch: 'full'},
      {path: ':menuSectionId', component: MenuMainContentComponent, pathMatch: 'full'}
    ]
  },
];

@NgModule({
  declarations: [
    EditProductModalComponent,
    EditModifierGroupComponent,
    EditModifierComponent,
    EditComboGroupComponent,
    EditComboProductComponent,
    EditGroupModalComponent,

    AddButtonComponent,
    ChangesForMenusComponent,
    MenuMainComponent,
    PageHeaderComponent,
    PageTitleComponent,
    PageSearchComponent,
    MenuChipsComponent,
    TagsFormFieldComponent,
    SelectImageFieldComponent,
    SectionGroupComponent,
    SectionProductsComponent,
    SectionProductComponent,
    MenuMainContentComponent,
    EditMenuModalComponent,
    SelectProductsModalComponent,
    SelectMenuGroupsModalComponent,
    ProductItemComponent,
    MenuSyncCardComponent,
    MenuEventModalComponent,
    EditSizeModalComponent,
    EditModifierGroupsModalComponent,
    MenuPipesModalComponent,
    EditSizeScaleModalComponent,
    DeleteSizeScaleDialogComponent,
    MenuSchedulesModalComponent,
    MenuSchedulesEntityModalComponent,
    SelectProductsScheduleModalComponent,
    SelectGroupsScheduleModalComponent,
    AllergenGroupComponent,
    EditTagModalComponent,
    TagsFormFieldOldComponent,
    EditMenuBackupComponent,
    SendProductModalComponent,
    ModifierGroupTypeModalComponent,
    SelectVideoFieldComponent,
    RelatedProductsComponent,
    EditRelatedProductsModalComponent,
    RelatedProductsV3Component,
    EditRelatedProductsV3ModalComponent,
    MigrateRelatedProductsDialogComponent,
    NutritionFormFieldComponent,
    ProductBarcodesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,

    // Material
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatChipsModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    MatListModule,
    MatCardModule,
    MatProgressBarModule,
    MatDialogModule,
    MatRadioModule,
    DragDropModule,
    PreloaderModule,
  ],
  exports: [RouterModule, SectionProductComponent, SelectImageFieldComponent]
})
export class MenuModule {
}
